module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// C:/wamp/www/node_modules/babel-runtime/core-js/object/create.js
// module id = 248
// module chunks = 0